/** Only send `description` when the user entered a new note (edit appends on the API). */
export function resolveProviderDescriptionForSave({ newDescription = "" } = {}) {
  const trimmedNew = String(newDescription || "").trim();
  return trimmedNew || null;
}

export function applyProviderDescriptionToPayload(payload, descriptionValue) {
  if (descriptionValue === null || descriptionValue === undefined) {
    return payload;
  }
  const text = String(descriptionValue);
  if (!text.trim()) {
    return payload;
  }
  return { ...payload, description: text.trim() };
}

export function extractProviderApiErrorMessage(error, fallback = "Request failed.") {
  const data = error?.response?.data;
  if (!data) return error?.message || fallback;

  const descriptionError = data?.errors?.description;
  if (Array.isArray(descriptionError) && descriptionError[0]) {
    return descriptionError[0];
  }

  if (typeof data?.error === "string" && data.error.trim()) {
    return data.error;
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }

  return fallback;
}
